import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import covestroDocumentIcon from "../../assets/imgs/covestro-document-icon.png";

interface DemoBannerProps {
  isDemo: boolean;
}

export const DemoBanner = ({ isDemo }: DemoBannerProps) => {
  const { t } = useTranslation();

  if (!isDemo) {
    return null;
  }

  return (
    <Box
      id="img20_demoBanner"
      sx={{
        background:
          "linear-gradient(to right, var(--global-magenta-magenta-6), var(--global-purple-purple-6))",
        borderRadius: "var(--spacing8)",
        padding: "var(--spacing24)",
        position: "relative",
        overflow: "hidden",
        marginBottom: "var(--spacing16)",
      }}
    >
      <Typography
        sx={{
          fontFamily: "var(--body-b2-14-medium-font)",
          fontSize: "var(--body-b2-14-medium-size)",
          fontWeight: "var(--body-b2-14-medium-weight)",
          lineHeight: "var(--body-b2-14-medium-line-height)",
          letterSpacing: "var(--body-b2-14-medium-tracking)",
          color: "var(--alias-text-on-special-primary)",
        }}
      >
        {t("demo_banner_title")}
      </Typography>
      {/* <Typography // CX-1597 [FE] Change Label Demo to Setting up your account
        sx={{
          fontFamily: "var(--body-b3-12-regular-font)",
          fontSize: "var(--body-b3-12-regular-size)",
          fontWeight: "var(--body-b3-12-regular-weight)",
          lineHeight: "var(--body-b3-12-regular-line-height)",
          letterSpacing: "var(--body-b3-12-regular-tracking)",
          color: "var(--alias-text-on-special-secondary)",
          mt: 0.5,
        }}
      >
        {t("demo_banner_subtitle")}
      </Typography> */}
      <Box
        component="img"
        src={covestroDocumentIcon}
        alt=""
        sx={{
          position: "absolute",
          bottom: "var(--spacing0)",
          right: "var(--spacing0)",
          height: "100%",
          // objectFit: "contain",
          // top: "var(--spacing0)"
        }}
      />
    </Box>
  );
};
